export const TYPE_APPROVE = 1;
export const TYPE_ALOWANCE = 2;
export const TYPE_REFUSED = 3;
export const TYPE_REJECTED = 4;
export const TYPE_TRANSFER = 5;
